
import moment from 'moment'
import EoButton from '../EoButton/EoButton'
import EoCard from './EoCard'
import EoIcon from '../EoIcon/EoIcon'

export default {
  name: 'EoCardTrack',
  components: {
    EoButton,
    EoCard,
    EoIcon,
  },
  inheritAttrs: false,
  props: {
    /**
     * Url to more information
     */
    infoUrl: {
      type: String,
      default: null,
    },
    /**
     * Duration: in seconds or in 01:00:00 format
     */
    duration: {
      type: [String, Number],
      default: null,
    },
    /**
     * Is this episode playing
     */
    playing: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: small card with media on the side
     */
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes () {
      return {
        'eo-card-track': true,
        'is-playing': this.playing,
      }
    },
    durationInMinutes () {
      if (!this.duration) return null
      let normalizedDuration
      if (Number(this.duration)) {
        normalizedDuration = Math.floor(this.duration / 60)
      } else {
        normalizedDuration = moment.duration(moment(this.duration, ['hh:mm:ss']).format('mm'), 'minutes').asMinutes()
      }
      return `${normalizedDuration} min`
    },
  },
}
